/**
 * Relaxed Lifestyler brand logo — "R-Play Monogram" (concept D, supplied by the user):
 * a heavy geometric purple R whose counter is cut as a play triangle, next to the wordmark.
 * size: "sm" | "md" | "lg" | "xl"
 * theme: "dark" (default, white "Relaxed") | "light" (dark "Relaxed" for light backgrounds)
 */
export const BRAND_PURPLE = "#7c3aed";

// Clean geometry measured from the user-supplied R-Play mark (memory/brand/ref_logo.jpeg, concepts.jpeg).
const R_PATH = "M0 0 H47.7 A31.3 31.3 0 0 1 79 31.3 V36 C79 48 64 56.8 54.8 61.8 L82.9 100 H55.7 L31.2 62 H22.5 V100 H0 Z M20.5 17 L59 31.5 L20.5 46.5 Z";
const R_VIEWBOX = "0 0 83 100";
const R_ASPECT = 0.83;

export const RPlayMark = ({ size = 24, color = BRAND_PURPLE, className = "" }) => (
  <svg
    width={size * R_ASPECT}
    height={size}
    viewBox={R_VIEWBOX}
    xmlns="http://www.w3.org/2000/svg"
    className={`flex-shrink-0 ${className}`}
    aria-hidden="true"
  >
    <path fillRule="evenodd" fill={color} d={R_PATH} />
  </svg>
);

export default function Logo({ size = "md", theme = "dark", className = "", showText = true }) {
  const sizes = {
    sm:  { top: "text-base", sub: "text-[8px]",  spacing: "tracking-[0.25em]", icon: 26 },
    md:  { top: "text-xl",   sub: "text-[9px]",  spacing: "tracking-[0.3em]",  icon: 36 },
    lg:  { top: "text-2xl",  sub: "text-[10px]", spacing: "tracking-[0.35em]", icon: 44 },
    xl:  { top: "text-3xl",  sub: "text-xs",     spacing: "tracking-[0.4em]",  icon: 56 },
  };
  const s = sizes[size] || sizes.md;
  const topColor = theme === "light" ? "#2C302E" : "#ffffff";

  return (
    <div dir="ltr" className={`inline-flex items-center gap-3 select-none ${className}`} data-testid="brand-logo">
      <RPlayMark size={s.icon} />
      {showText && (
        <div className="flex flex-col leading-none">
          <span
            className={`${s.top} font-black uppercase`}
            style={{ fontFamily: "Epilogue, 'DM Sans', system-ui, sans-serif", letterSpacing: "0.01em", color: topColor, lineHeight: 1 }}
          >
            Relaxed
          </span>
          <span
            className={`${s.sub} font-semibold uppercase ${s.spacing} mt-1`}
            style={{ fontFamily: "Epilogue, 'DM Sans', system-ui, sans-serif", color: BRAND_PURPLE }}
          >
            Lifestyler
          </span>
        </div>
      )}
    </div>
  );
}
